<div class=" bg-gray-20 lg:border-b border-gray-300">
    <div class=" container mx-auto lg:mb-10  ">

        <div class="flex flex-col lg:flex-row mx-auto">
            <div class="w-full">
                <p class="text-xl text-[var(--charcoal)] mt-4"> Items, Tickets, Donations and Quick Sales are
                    automatically added to your My Purchases page when the organization finalizes each purchase. If you
                    have any questions about a purchase, please contact the organization by clicking the Auction Name
                    and then Contact Us.
                </p>
            </div>
        </div>


        <ng-container *ngIf="isLoading() ; else content">


            <div class="flex items-center justify-center min-h-[300px]">
                <p-progress-spinner ariaLabel="loading My favorites" />
            </div>
        </ng-container>

        <ng-template #content>

            <div class="w-full">
                <div class="flex justify-end mb-4 lg:mb-8">
                    <p-select [options]="sortFilters" [ngModel]="selectedSortSignal()" placeholder="Sort by" class=""
                        (onChange)="onSortChange($event)">
                    </p-select>
                </div>

                <app-my-purchases-page [purchasesResponse]="myPurchasesResponse()"></app-my-purchases-page>

            </div>

            <!-- @if(items().length > 10)
        {
        } -->

            <p-paginator [rows]="filters().per" [totalRecords]="totalPurchases()"
                [rowsPerPageOptions]="rowsPerPageOptions" (onPageChange)="onPageChange($event)"
                styleClass="mt-7 text-sm">
            </p-paginator>

        </ng-template>
    </div>
</div>